import { render, staticRenderFns } from "./UserNotificationListItem.vue?vue&type=template&id=739dac2e&scoped=true&"
import script from "./UserNotificationListItem.vue?vue&type=script&lang=ts&"
export * from "./UserNotificationListItem.vue?vue&type=script&lang=ts&"
import style0 from "./UserNotificationListItem.vue?vue&type=style&index=0&id=739dac2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739dac2e",
  null
  
)

export default component.exports